import { render, staticRenderFns } from "./PortalsListPosts.vue?vue&type=template&id=2dc8479c&"
import script from "./PortalsListPosts.vue?vue&type=script&lang=js&"
export * from "./PortalsListPosts.vue?vue&type=script&lang=js&"
import style0 from "./PortalsListPosts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports